import { connect } from 'react-redux';
import { branch, compose, renderNothing } from 'recompose';

import { getBrandSmsOriginator } from '../auth/selectors';
import { canUseChat } from '../common/helpers/users';

const renderIfChatAvailable = compose(
    connect(state => ({
      smsOriginator: getBrandSmsOriginator(state),
      chatAvailable: canUseChat(state),
    })),
    branch(props => !props.smsOriginator || !props.chatAvailable, renderNothing),
);

export default renderIfChatAvailable;
